<template>
  <div>
    <div style="width: 375px">
      <div class="service-box "  :style="{'height':open_status == true?'667px':'0'}" :class="[open_status == true?'animated bounceInRight':'']">
        <iframe :src="src" frameborder="0"  scrolling="No"  leftmargin="0" topmargin="0"></iframe>
      </div>
    </div>

    <div class="service"  @click="openOrChoose">
      <img src="../assets/service.png" alt="">
      <div class="hoverBox" v-if="hoverStatus=='already'">
        <!--<div class="hoverTitle">请选择客服平台</div>-->
        <div class="hoverBtn">
          <div class="toFastgo" @click.stop="openService(1)">FASTGO 客服</div>
          <div class="toSydeny" @click.stop="openService(12)">悉尼处理中心 客服</div>
        </div>

      </div>
    </div>
  </div>


</template>

<script>
  import { mapState } from 'vuex'
    export default {
      name: "Service",
      data(){
          return{
            open_status:false,
            src:'',
            hoverStatus:'close',
            platformId:''
          }
      },
      computed:{
        ...mapState({
          userInfo:state=>state.userInfo,


        })
      },
      methods:{
        openOrChoose(){
          if(this.hoverStatus == 'close'||this.hoverStatus == 'already'){
            if(this.hoverStatus == 'close'){
              this.hoverStatus = 'already'
            }else{
              this.hoverStatus = 'close'
            }

          }else{
            this.open_status = !this.open_status;
          }
        },
        openService(platformId){
          this.platformId = platformId;
          var userType = '';
          var iframeSrc = '';
          if(JSON.stringify(this.userInfo) == '{}'){
            userType = 'unknow'
            iframeSrc = 'https://im.fastgo.com.au/imh5_m/dist/index.html#/simpleChat?type='+userType+'&platformId='+ this.platformId
          }else{
            userType = 'normal'
            iframeSrc = 'https://im.fastgo.com.au/imh5_m/dist/index.html#/simpleChat?uid='+this.userInfo.uid+'&nickname='+this.userInfo.nickname+'&type='+userType+'&openid='+this.userInfo.openid+'&platformId='+this.platformId
          }
          this.hoverStatus = 'success'
          this.open_status = !this.open_status;
          if(!this.src){
            if(this.open_status){
              this.src = iframeSrc
            }else{
              this.src = ''
            }
          }
        },
        choosePlatformId(){

        }
      }
    }
</script>

<style scoped lang="scss">
  .service-box{
    width: 375px;
    height: 667px;
    position: fixed;
    right: 70px;
    bottom: 80px;
    background: #fff;
    overflow: hidden;
    z-index: 999;
    iframe{
      width: 375px;
      height: 667px;
    }
  }
  .service{
    position: fixed;
    right: 10px;
    bottom: 80px;
    background: $bg-color;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1000;
    img{
      width: 40px;
      margin-left: 5px;
      margin-top: 5px;
    }
    .hoverBox{
      position: absolute;
      top: -80px;
      right: 40px;
      width: 200px;
      /*height: 100px;*/
      background: #fff;
      border-radius: 2px;
      box-shadow: 0 0 8px 2px rgba(0,0,0,0.1);
      padding: 5px;
      /*.hoverTitle{*/
        /*width: 100%;*/
        /*line-height: 26px;*/
        /*text-align: center;*/
        /*font-size: 16px;*/
      /*}*/
      .hoverBtn{
        /*width: 100%;*/
        padding: 0 30px;
        div{
          line-height: 30px;
        }
        /*.toFastgo{*/
          /*float: left;*/
          /*margin-top: 20px;*/
        /*}*/
        /*.toSydeny{*/
          /*float: right;*/
          /*margin-top: 20px;*/
        /*}*/
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Service.vue